/*
 * @Author: yuhaiyangz@163.com
 * @Date: 2026-01-30 09:41:31
 * @LastEditors: yuhaiyang yuhaiyangz@163.com
 * @LastEditTime: 2026-04-16 17:25:49
 * @FilePath: \ccxd_app_react_mobile\src\unit\lng.js
 * @Description: 
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
const translationObj = {
    zh:{translation:{
        lang:'语言',
        home:'首页',
        indexDetails:'指数详情',
        dataDownload:'资料下载',
        overview:'指数简介',
        indexName:'指数名称',
        indexCode:'指数代码',
        indexShortName:'指数简称',
        baseDate:'基日',
        baseValue:'基点',
        pushDate:'发布时间',
        rebalancingFrequency:'调仓频率',
        methodWeight:'加权方式',
        performance:'指数表现',
        HRRS:'历史风险收益统计',
        AR:'年化收益率',
        AV:'年化波动率',
        CYP:'分年统计',
        nY:"注释：不足一年为区间收益率",
        SR:'夏普比例',
        MD:'最大回撤',
        zjr:'自基日',
        homePath:'首页',
        llqPath:'指数浏览器',
        khPath:'我们的客户',
        khPath1:'商业银行',
        khPath2:'银行理财',
        khPath3:'公募基金',
        khPath4:'证券公司',
        jjfaPath:'解决方案',
        jjfaPath1:'跨资产配置',
        jjfaPath2:'债券指数与估值',
        jjfaPath3:'基金研究与投资',
        newsPath:'新闻与公告',
        yjPath:'研究成果',
        gywmPath:'关于我们',
        gywmPath1:'公司介绍',
        gywmPath2:'加入我们',
        gywmPath3:'联系我们',
        gywmPath4:'合规管理',
        lxwm:'联系我们',
        phone:'电话',
        address:'地址',
        email:'邮箱',
        addressName:'中国·北京东城区朝阳门内大街南竹杆胡同2号银河SOHO-B座20621',
        change:'涨跌',
        historyTable:{
            a:'指数简称',
            b:'近1个月',
            c:'近3个月',
            d:'近6个月',
            e:'近1年',
            f:'近3年',
            g:'近5年',
            h:'自基日'
        },
        nav:'导航'
    }},
    en:{translation:{
        lang:'language',
        home:'Home',
        indexDetails:'Index Details',
        dataDownload:'Data Download',
        overview:'Index Overview',
        indexName:'Index Name',
        indexCode:'Index Code',
        indexShortName:'Index Name',
        baseDate:'Base Date',
        baseValue:'Base Value',
        pushDate:'Launch Date',
        rebalancingFrequency:'Rebalancing Frequency',
        methodWeight:'Weighting Method',
        performance:'Index Performance',
        HRRS:'Historical Risk & Return Statistics',
        AR:'Annualized Return',
        AV:'Annualized Volatility',
        CYP:'Calendar Year Performance',
        nY:"Note: For periods shorter than one year, returns are cumulative period returns.",
        SR:'Sharpe Ratio',
        MD:'Maximum Drawdown',
        zjr:'Since Inception',
        homePath:'Home',
        llqPath:'Index Browser',
        khPath:'Our Clients',
        khPath1:'Commercial Banks',
        khPath2:'Bank Wealth Management Subsidiaries',
        khPath3:'Public Mutual Funds',
        khPath4:'Securities Firms',
        jjfaPath:'Solutions',
        jjfaPath1:'Cross-Asset Allocation',
        jjfaPath2:'Bond Index and Valuation',
        jjfaPath3:'Fund Research and Investment',
        newsPath:'News & Announcements',
        yjPath:'Research',
        gywmPath:'About Us',
        gywmPath1:'Company Introduction',
        gywmPath2:'Join Us',
        gywmPath3:'Contact Us',
        gywmPath4:'Compliance Management',
        lxwm:'Contact Us',
        phone:'Phone',
        address:'Address',
        email:'Email',
        addressName:'Room 20621, Tower B, Galaxy SOHO, No. 2 Nanzhugan Hutong, Chaoyangmen Inner Street, Dongcheng District, Beijing, China',
        change:'Change',
        historyTable:{
            a:'Index Name',
            b:'1 Month',
            c:'3 Months',
            d:'6 Months',
            e:'1 Year',
            f:'3 Years',
            g:'5 Years',
            h:'Since Inception'
        },
        nav:'Navigation'
    }}
}
const getLangFromURL = () => {
  const match = window.location.pathname.match(/^\/(zh|en)(\/|$)/);
  return match ? match[1] : 'zh';
};
i18n
  .use(LanguageDetector) // 检测用户语言
  .use(initReactI18next) // 将 i18n 实例传递给 react-i18next
  .init({
    resources:translationObj,
    fallbackLng: 'zh', // 默认语言
    lng: getLangFromURL(), // 初始化语言
    debug: process.env.NODE_ENV === 'development', // 开发模式开启调试
    interpolation: {
      escapeValue: false // React 已经安全转义，不需要额外处理
    }
  });

export default i18n;